const STORAGE_KEY_REGEX = /^[A-Za-z0-9._:-]+$/;
const MAX_STORAGE_KEY_LENGTH = 128;
const MAX_STORAGE_VALUE_LENGTH = 50000;

const validateStorageKey = (key, functionName) => {
  // Constraint 1: type check
  if (typeof key !== "string") {
    console.error(`${functionName}: key must be a string`);
    return null;
  }

  const normalizedKey = key.trim();
  if (normalizedKey === "") {
    console.error(`${functionName}: key must be a non-empty string`);
    return null;
  }

  // Constraint 2: length check
  if (normalizedKey.length > MAX_STORAGE_KEY_LENGTH) {
    console.error(
      `${functionName}: key length cannot exceed ${MAX_STORAGE_KEY_LENGTH} characters`
    );
    return null;
  }

  // Constraint 3: allowlist format check
  if (!STORAGE_KEY_REGEX.test(normalizedKey)) {
    console.error(
      `${functionName}: key contains invalid characters. Allowed: letters, numbers, ., _, :, -`
    );
    return null;
  }

  return normalizedKey;
};

const validateStorageValue = (value, functionName) => {
  // Constraint 1: type presence check
  if (value === undefined) {
    console.error(`${functionName}: value cannot be undefined`);
    return null;
  }

  const normalizedValue = String(value);

  // Constraint 2: length check
  if (normalizedValue.length > MAX_STORAGE_VALUE_LENGTH) {
    console.error(
      `${functionName}: value length cannot exceed ${MAX_STORAGE_VALUE_LENGTH} characters`
    );
    return null;
  }

  // Constraint 3: control character check (block non-printable chars except line breaks/tabs)
  if (/[^\t\n\r -~]/.test(normalizedValue)) {
    console.error(
      `${functionName}: value contains unsupported control characters`
    );
    return null;
  }

  return normalizedValue;
};




export const localStorageGetItem = (key) => {
  try {
    const normalizedKey = validateStorageKey(key, "localStorageGetItem");
    if (!normalizedKey) {
      return null;
    }
    const encryptedValue = localStorage.getItem(normalizedKey);
    if (!encryptedValue) return null;

    return encryptedValue;
  } catch (error) {
    console.error(
      `Error getting item from localStorage for key "${key}":`,
      error
    );
    return null;
  }
};

export const localStorageSetItem = (key, value) => {
  try {
    const normalizedKey = validateStorageKey(key, "localStorageSetItem");
    if (!normalizedKey) {
      return;
    }
    const normalizedValue = validateStorageValue(value, "localStorageSetItem");
    if (normalizedValue === null) {
      return;
    }

    localStorage.setItem(normalizedKey, normalizedValue);
    return true;


  } catch (error) {
    console.error(
      `Error setting item in localStorage for key "${key}":`,
      error
    );
  }
};

export const localStorageRemoveItem = (key) => {
  const normalizedKey = validateStorageKey(key, "localStorageRemoveItem");
  if (!normalizedKey) {
    return;
  }
  try {
    return localStorage.removeItem(key);
  } catch (error) {
    console.error(
      `Error removing item from localStorage for key "${key}":`,
      error
    );
  }
};

export const localStorageClear = () => {
  localStorage.clear();
};

export const sessionStorageGetItem = (key) => {
  const normalizedKey = validateStorageKey(key, "sessionStorageGetItem");
  if (!normalizedKey) {
    return;
  }
  try {
    return sessionStorage.getItem(normalizedKey);
  } catch (error) {
    console.error(
      `Error getting item from sessionStorage for key "${key}":`,
      error
    );
    return null;
  }
};

export const sessionStorageSetItem = (key, value) => {
  const normalizedKey = validateStorageKey(key, "sessionStorageSetItem");
  if (!normalizedKey) {
    return;
  }
  const normalizedValue = validateStorageValue(value, "sessionStorageSetItem");
  if (normalizedValue === null) {
    return;
  }
  try {
    return sessionStorage.setItem(normalizedKey, normalizedValue);
  } catch (error) {
    console.error(
      `Error setting item in sessionStorage for key "${key}":`,
      error
    );
  }
};

export const sessionStorageRemoveItem = (key) => {
  const normalizedKey = validateStorageKey(key, "sessionStorageRemoveItem");
  if (!normalizedKey) {
    return;
  }
  try {
    return sessionStorage.removeItem(normalizedKey);
  } catch (error) {
    console.error(
      `Error removing item from sessionStorage for key "${normalizedKey}":`,
      error
    );
  }
};

